import React from "react";
import Container from "./container";
import { cn } from "../lib/helpers";
import PortableText from "./portableText";
import { buildImageObj } from "../lib/helpers";
import { imageUrlFor } from "../lib/image-url";

import * as styles from "../styles/components/fc-regular-content.module.css";

const RegularContent = (props) => {

  const {
    title,
    _rawContent,
    image
  } = props;

  return (
    <div className={styles.root}>
      <Container>
        {title && (<h2 className={styles.title}>{title}</h2>)}
        {_rawContent && (<div className={cn("entry-content", styles.contentWrap)}><PortableText blocks={_rawContent} /></div>)}
        {image && image.asset && (
          <div className={styles.image}>
            <img
              src={imageUrlFor(buildImageObj(image))
                .auto("format")
                .url()}
              alt={image.alt}
            />
          </div>
        )}
      </Container>
    </div>
  );
}

export default RegularContent;
